export const FILTER_OPTIONS = {
  ALL: "all",
  ZERO: "zero",
  RANGE: "range",
  ANY: "any",
} as const;

export const FILTER_OPTION_LABELS = {
  ACCEPT_REJECT: {
    all: "All",
    zero: "Rejected",
    range: "Accepted",
    any: "Any",
  },
  INTERSECTION: {
    all: "Both",
    zero: "No intersection",
    range: "Intersected",
  },
  EMPTY_MANY: {
    all: "All",
    zero: "Empty",
    range: "Many",
  },
  TRACK: {
    all: "All",
    zero: "Empty",
    range: "Single",
  },
} as const;

export const SKU_SECTION_COLORS = {
  NO_CHANGES: "#808080",
  TRIANGULATION: "#007BFF",
  DETECTION: "#EF5F00",
  OCCLUSION: "#F8CF00",
  CLOSEST_GONDOLA_DIST: "#28A745",
} as const;

export type FilterOption = (typeof FILTER_OPTIONS)[keyof typeof FILTER_OPTIONS];
export type FilterOptionLabels =
  (typeof FILTER_OPTION_LABELS)[keyof typeof FILTER_OPTION_LABELS];
